import { AYS_VIRTUAL_CLINIC_SELECT_OPTIONS_DISABLE_FNC_DEFAULT } from '@bindoc-projects/virtual-clinic-lib/ui';
import { BdResourcesSelectInlineConfig } from '@bindoc-projects/resource-lib/data';
import { AysVirtualClinic } from '@bindoc-projects/virtual-clinic-domain-lib';
import { Type } from '@angular/core';
import { ShareableType } from '@bindoc-projects/resource-domain-lib';

export interface KostDataImportTargetConfig {
  virtualClinicSelectOptions: BdResourcesSelectInlineConfig<AysVirtualClinic>;
  termsAndConditions: {
    dialog: Type<unknown>;
    tosDate: Date;
  };
  resourceName: ShareableType;
}

export const KOST_DATA_IMPORT_TARGET_CONFIG_VIRTUAL_CLINICS_SELECT_OPTIONS_DEFAULT: BdResourcesSelectInlineConfig<AysVirtualClinic> =
  {
    emptyResourcesText: 'Keine Virtuellen Kliniken gespeichert',
    selectOnInit: 'none',
    disableFnc: AYS_VIRTUAL_CLINIC_SELECT_OPTIONS_DISABLE_FNC_DEFAULT,
    filterFnc: (virtualClinic) => {
      if (virtualClinic.clinicInformation?.origin) {
        return virtualClinic.clinicInformation.origin.type === 'UserCreated';
      }

      return false;
    },
    minPermission: 'UPDATE',
    detailLinkFnc: () => [],
    resourceNameTitle: 'Virtuelle Klinik',
    resetOption: false,
  };
